// CI: nx affected – front-visitors-area (deploy trigger) v2
import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

console.log('Starting application...', 'COMMIT____SHA');

if (environment?.sentryDns) {
  Sentry.init({
    dsn: environment.sentryDns,
    debug: !environment.production,
    dist: environment.releaseName,
    environment: environment.releasePhase,
    release: 'COMMIT____SHA',
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [environment.api, /^\//],
    tracesSampleRate: 0.1,
    profilesSampleRate: 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
  });
  scheduleSentryReplay();
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    defaultEncapsulation: ViewEncapsulation.Emulated,
  })
  .catch(err => console.error(err));

function scheduleSentryReplay(): void {
  const addReplayIntegration = (): void => {
    Sentry.addIntegration(Sentry.replayIntegration());
  };
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(addReplayIntegration);
    return;
  }
  setTimeout(addReplayIntegration, 2000);
}
// k8s-test environment initial deployment
